module.exports = __webpack_public_path__ + "img/icon-changes-nor.2b64bbd5.svg";